import {
    GETMAPPINGBANKALLLIST_SUCCESS,
    GETMAPPINGBANKALLLIST_FAILED,
    RESET_GETMAPPINGBANKALLLIST,
    LOADING_GETMAPPINGBANKALLLIST,
    NETWORK_ERROR_GETMAPPINGBANKALLLIST
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetGetMappingBankAllList = () => {
    return { type: RESET_GETMAPPINGBANKALLLIST };
};

const partnerGetMappingBankAllList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMAPPINGBANKALLLIST });
    await partnerServices
        .post("getMappingBankAllList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerGetMappingAllBankListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerGetMappingAllBankListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMAPPINGBANKALLLIST,
                payload: err
            });
        });
};

function partnerGetMappingAllBankListsuccess(data) {
    return {
        type: GETMAPPINGBANKALLLIST_SUCCESS,
        payload: data,
    };
}

function partnerGetMappingAllBankListFailed(data) {
    return {
        type: GETMAPPINGBANKALLLIST_FAILED,
        payload: data,
    };
}

export { resetGetMappingBankAllList, partnerGetMappingBankAllList }